Controller.$inject = [];

function Controller() {
    let self = this;
    self.updateSlider = () => {
        let percentage = ((self.ngModel - self.min) / (self.max - self.min)) * 100;
        self.filledWidth = percentage + '%';
    };

    self.onInputChange = () => {
        self.updateSlider();
    };

    const getSliderSteps = (min, max, step) => {
        let steps = [];
        for (let i = min; i <= max; i += step) {
            steps.push(i);
        }
        return steps;
    };

    self.$onInit = () => {
        self.sliderSteps = getSliderSteps(self.min, self.max, self.step);
    };
}

export function HuiInputSlider() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            ngModel: '=',
            min: '<',
            max: '<',
            step: '<',
            color: '@',
            hName: '@',
            sizing: '@'
        },
        transclude: true,
        controller: Controller,
        controllerAs: '$huiCtrl',
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-input-slider"
                     role="slider"
                     aria-valuetext="{{ $huiCtrl.ngModel }}"
                     aria-valuenow="{{ $huiCtrl.ngModel }}"
                     aria-valuemin="{{ $huiCtrl.min }}"
                     aria-valuemax="{{ $huiCtrl.max }}"
                     tabindex="0"
                     ng-class="['hui-' + ($huiCtrl.color || 'accent'),
                                ($huiCtrl.sizing || 'md')]">
                    <div class="hui-input-slider-track">
                         <div class="hui-input-slider-filled" 
                              ng-class="['hui-' + ($huiCtrl.color || 'accent')]"
                              ng-style="{ width: $huiCtrl.filledWidth}">
                              <div class="hui-input-slider-thump" 
                                    ng-class="['hui-' + ($huiCtrl.color || 'accent')]"></div>
                         </div>  
                    </div>
                     <input type="range" min="{{$huiCtrl.min}}" max="{{$huiCtrl.max}}" step="{{$huiCtrl.step}}" 
                            aria-hidden="true"
                            name="{{$huiCtrl.hName}}"                  
                            class="hui-slider-input" 
                            ng-model="$huiCtrl.ngModel" 
                            ng-change="$huiCtrl.onInputChange()" />     
                </div>
            `;
        }
    };
}